.bc{padding:0.5rem;}